import { Box, styled } from '@mui/material'

export const StyledChartBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '90%',
  margin: theme.spacing(4, 'auto'),
  padding: theme.spacing(3),
  maxWidth: '800px',
  borderRadius: theme.spacing(2.5),
  border: `1.5px solid ${theme.palette.primary.main}`,
  boxShadow: `-8px 8px 0px ${theme.palette.primary.light}`,
  overflow: 'hidden',
  [theme.breakpoints.up('md')]: {
    width: '100%',
  },
}))
